const data = [
    {
        id: 1,
        title: "Mount Fuji",
        location: "Japan",
        googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
        startDate: "12 Oct, 2024",
        endDate: "24 Oct, 2024",
        description: "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
        imageUrl: "https://source.unsplash.com/WLxQvbMyfas"
    },
    {
        id: 2,
        title: "Mauna Kea",
        location: "Hawai'i",
        googleMapsUrl: "https://maps.app.goo.gl/RyoMqwgMPCAAbENn7",
        startDate: "13 Aug, 2022",
        endDate: "20 Aug, 2022",
        description: "Mauna Kea is an inactive volcano on the island of Hawaiʻi. Its peak is 4,207.3 m above sea level, making it the highest point in the state of Hawaii and second-highest peak of an island on Earth.",
        imageUrl: "https://www.tripsavvy.com/thmb/OBoj4Xo8dQqccLS4laiVu5l9dVI=/750x0/filters:no_upscale():max_bytes(150000):strip_icc()/GettyImages-160835692-c705bd50446f4b50a1a66a67e8ca4596.jpg"
    },
    {
        id: 3,
        title: "Breckenridge",
        location: "Colorado",
        googleMapsUrl: "https://maps.app.goo.gl/GSyRYWiTKH4TqZBr6",
        startDate: "22 Dec, 2017",
        endDate: "28 Dec, 2017",
        description: "Breckenridge is a Colorado town at the base of the Rocky Mountains’ Tenmile Range. It's known for its ski resort, year-round alpine activities and Gold Rush history. The Victorian core of this former mining town is preserved as the Breckenridge National Historic District, running primarily along Main Street, with colorfully painted buildings from the 1880s and '90s housing shops, galleries and restaurants.",
        imageUrl: "https://encrypted-tbn2.gstatic.com/licensed-image?q=tbn:ANd9GcSBYNb_iNp5xJleuPNLYUAie_6o6w9LkVZZK9tpr9gn7x0F3_5tSFvN4l7bFpjr9jF9TS9wFkILJ7mm8qCZhiDOSBZxAbmJeIdjoJtzjA"
    },
]

export default data